import { API_VALIDADOR as API } from "@/api";
import axios from "axios";

class CompanyProviderService {
  getCompanyProvidersByDocument(params) {
    return axios.get(API.company_providers_by_document, { params });
  }
  getCompanyProviderDetail(id) {
    return axios.get(API.company_provider_detail(id));
  }
}

const instance = new CompanyProviderService();
export default instance;
